export enum TrafficPriority {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
    UNLIMITED = 'unlimited',
}